module.exports = __webpack_public_path__ + "static/media/game_cover_baseball@768.680d5a8a.png";